import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
// import {
//   Link,
//  } from '../../components'
import ReactPlayer from 'react-player'

const Styles = require('./PlanScorecardCompanyVideo.css')

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardCompanyVideo extends Component {
  static propTypes = {
    shortName: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      videoId: config.companyVideoIds[props.shortName] || null
    }
  }

  render() {
    if (!this.state.videoId) {
      return null
    }

    return (
      <div styleName='media-react-player-wrap-wrap'>
        <div styleName='media-react-player-wrap'>
          <ReactPlayer
            url={'https://vimeo.com/' + this.state.videoId}
            volume={0.5}
            config={{
              vimeo: {
                playerOptions: {
                  texttrack: 'en-US'
                }
              }
            }}
          />
        </div>
      </div>
    )
  }
}